import { render, staticRenderFns } from "./importVIBANModal.vue?vue&type=template&id=60a9dc4c&scoped=true&"
import script from "./importVIBANModal.vue?vue&type=script&lang=js&"
export * from "./importVIBANModal.vue?vue&type=script&lang=js&"
import style0 from "./importVIBANModal.vue?vue&type=style&index=0&id=60a9dc4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9dc4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a9dc4c')) {
      api.createRecord('60a9dc4c', component.options)
    } else {
      api.reload('60a9dc4c', component.options)
    }
    module.hot.accept("./importVIBANModal.vue?vue&type=template&id=60a9dc4c&scoped=true&", function () {
      api.rerender('60a9dc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/importVIBANModal.vue"
export default component.exports